export class Account {
  public accountId: string;
  public fullName: string;
  public password: string;
  public address: string;
  public emailAddress: string;
  public postalCode: string;
  public phoneNo: string;
  public banExpiryDate: Date;
  public status: string;
  public suspendedRemarks: string;
  public locationAllowQty: number;
  public accountType: string;
  public mainAccountId: string;
  public bookingNoShow: number;
  public receiveEmailReminder: number;
  public loginFailCount: number;
  public registDate: Date;
  public registPname: string;
  public lastUpdateDate: Date;
  public lastUpdatePname: string;
  public actionBy: string;

  constructor(
    accountId: string,
    fullName: string,
    password: string,
    address: string,
    emailAddress: string,
    postalCode: string,
    phoneNo: string,
    banExpiryDate: Date,
    status: string,
    suspendedRemarks: string,
    locationAllowQty: number,
    accountType: string,
    mainAccountId: string,
    bookingNoShow: number,
    receiveEmailReminder: number,
    loginFailCount: number,
    registDate: Date,
    registPname: string,
    lastUpdateDate: Date,
    lastUpdatePname: string
  ) {
    this.accountId = accountId;
    this.fullName = fullName;
    this.password = password;
    this.address = address;
    this.emailAddress = emailAddress;
    this.postalCode = postalCode;
    this.phoneNo = phoneNo;
    this.banExpiryDate = banExpiryDate;
    this.status = status;
    this.suspendedRemarks = suspendedRemarks;
    this.locationAllowQty = locationAllowQty;
    this.accountType = accountType;
    this.mainAccountId = mainAccountId;
    this.bookingNoShow = bookingNoShow;
    this.receiveEmailReminder = receiveEmailReminder;
    this.loginFailCount = loginFailCount;
    this.registDate = registDate;
    this.registPname = registPname;
    this.lastUpdateDate = lastUpdateDate;
    this.lastUpdatePname = lastUpdatePname;
  }
}
